import api from '@/api/index'

export const chatApi = {
    createSession: (params) => {
        return api.sendPostRequest('/llm/chat/createSession', params)
    },
    getChatLists: (params) => {
        return api.sendGetRequest('/llm/chat/getSessionList', params)
    },
    modifySessionName: (params) => {
        return api.sendPostRequest('/llm/chat/modifySessionName', params)
    },
    deleteSession: (params) => {
        return api.sendPostRequest('/llm/chat/deleteSession', params)
    },
    messageLike: (params) => {
        return api.sendPostRequest('/llm/chat/messageLike', params)
    },
    getMessageList: (params) => {
        return api.sendGetRequest('/llm/chat/messageList', params)
    },
    getPromptList: (params) => {
        return api.sendGetRequest('/llm/chat/getPromptList', params)
    },
    saveMsgApi: (params) => {
        return api.sendPostRequest('/llm/chat/saveMsg', params)
    },
    deleteMsgApi: (params) => {
        return api.sendPostRequest('/llm/chat/deleteMsg', params)
    },
    getSceneLists: (params) => {
        return api.sendGetRequest('/llm/square/getSceneList', params)
    },
    getSenceType: (params) => {
        return api.sendGetRequest('/llm/square/getSceneOptions', params)
    },
    getRecommendWords: (params) => {
        // return api.sendGetRequest(
        //   'https://mockapi.eolink.com/IDgNkPT457c28ffac0246e61ecc7c51697597519ffe7b00/llm/square/getRecommendWords',
        //   params
        // )
        return api.sendGetRequest('/llm/square/getRecommendWords', params)
    },
    notRecommendScene: (params) => {
        return api.sendGetRequest('/llm/square/notRecommend', params)
    },
    getAssociateScene: (params) => {
        return api.sendPostRequest('/llm/square/associateScene', params)
    },
    getFormsBySceneId: (params) => {
        return api.sendGetRequest('/llm/square/getFormsBySceneId', params)
    },
    useAssociateScene: (params) => {
        return api.sendGetRequest('/llm/square/useAssociateScene', params)
    },
    changeMessageStatus: (params) => {
        return api.sendPostRequest('/llm/chat/changeMessageStatus', params)
    },
    shareChat: (params) => {
        return api.sendPostRequest('/llm/chat/share', params)
    },
    getShareMessage: (params) => {
        return api.sendGetRequest('/llm/chat/getShareMessage', params)
    },
    getImages: (params) => {
        return api.sendGetRequest('/llm/mode/getImages', params)
    }
}
